<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>首页</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>后台管理员列表</el-breadcrumb-item>
        <el-breadcrumb-item>添加管理员</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">添加管理员</span>
      </div>
      <div class="xcx-content">
        <el-form ref="form_data" :model="form_data" :rules="rules" label-width="160px" style="width: 80%">
          <el-form-item label="角色：" prop="role_id">
            <el-col :span="20">
              <el-select v-model="form_data.role_id" placeholder="请选择品牌">
                <el-option label="请选择" :value="0"></el-option>
                <el-option v-for="item in roleList" :key="item.role_id" :label="item.role_name" :value="item.role_id"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="用户名：" prop="username">
            <el-input v-model="form_data.username" placeholder="请输入站点标题"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="password">
            <el-input type="password" v-model="form_data.password" placeholder="请输入分享关键词"></el-input>
          </el-form-item>
          <el-form-item label="联系人：" prop="contact">
            <el-input v-model="form_data.contact" placeholder="请输入分享描述"></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model="form_data.mobile" placeholder="请输入分享描述"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input v-model="form_data.remark" placeholder="请输入分享描述"></el-input>
          </el-form-item>
          <el-form-item label="状态：" prop="status">
            <el-radio-group v-model="form_data.status">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="mar_T_50">
            <el-button type="primary" @click="submitForm('form_data')" v-if="id">确认修改</el-button>
            <el-button type="primary" @click="submitForm('form_data')" v-else>确认添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      roleList: [],
      form_data: {
        role_id: 0,
        username: "",
        password: "",
        contact: "",
        mobile: "",
        remark: "",
        status: 1,
      },
      id: "",
      rules: {
        role_id: [{ required: true, message: "请选择角色", trigger: "change" }],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    var that = this;
    that.getRole();
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getDetail();
    }
  },
  methods: {
    getRole() {
      var that = this;
      that.axios.post("/role/getCate").then((res) => {
        if (res) {
          that.roleList = res.data;
          that.loading = false;
        }
      });
    },

    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/admin/edit", { id: that.id }).then((res) => {
        if (res) {
          if (res.data) {
            that.form_data = res.data;
          }
        }
      });
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.form_data;
        var url = "/admin/store";
        if (that.id) {
          formData.id = that.id;
          url = "/admin/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/admin/index");
        });
      });
    },
  },
};
</script>
<style>
</style>